import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const destroyOliveUser = async (id: string): Promise<AxiosResponse> => {
  const response = await axios
    .delete(`/api/olive-users/${id}`)
    .catch((error) => {
      return error.response
    })

  return response
}
